/* @index('./*.ts', f => `export * from '${f.path}';`) */
export * from './format-badge-number.module';
export * from './format-badge-number.pipe';
/* @endindex */
